import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchEmployees } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const EmployeeDropdownReportRole = ({ errors, control, setValue, getValues, watch, rowData, onChange }) => {
  const selectedEmployeeId = watch("employee_id");
  // console.log("rowdat", rowData)

  const { data: employees, isLoading, error } = useQuery(["Employees"], fetchEmployees, {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const options = useMemo(() => {
    return (
      employees?.data?.data?.map((ele) => ({
        value: ele?.employee_code_id,
        label: ele?.employee_name,
      })) || []
    );
  }, [employees]);

  const selectedOption = useMemo(() => {
    return options.find((option) => option?.value === Number(selectedEmployeeId)) || null;
  }, [options, selectedEmployeeId]);

  useEffect(() => {
    if (rowData?.employee?.length > 0 && rowData.employee[0]?.employee_code_id) {
      setValue("employee_id", rowData.employee[0].employee_code_id);
    }
  }, [rowData, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Employees</div>;

  return (
    <Controller
      name="employee_id"
      control={control}
      rules={{ required: "Employee is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Employee"
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("employee_id", value);

            if (onChange) {
              onChange(selectedOption);
            }
          }}
          className={`react-select-container ${errors?.employee_id ? "is-invalid" : ""}`}
        />
      )}
    />
  );
};

export default EmployeeDropdownReportRole;